/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One bucket of test execution
 * @export
 * @interface InternalScenarioContentTestBucket
 */
export interface InternalScenarioContentTestBucket {
    /**
     * In milliseconds. If null, then is starting bucket
     * @type {number}
     * @memberof InternalScenarioContentTestBucket
     */
    from?: number;
    /**
     * In milliseconds. If null, then is ending bucket
     * @type {number}
     * @memberof InternalScenarioContentTestBucket
     */
    to?: number;
    /**
     * Count of executions in this bucket
     * @type {number}
     * @memberof InternalScenarioContentTestBucket
     */
    count: number;
}

/**
 * Check if a given object implements the InternalScenarioContentTestBucket interface.
 */
export function instanceOfInternalScenarioContentTestBucket(value: object): value is InternalScenarioContentTestBucket {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function InternalScenarioContentTestBucketFromJSON(json: any): InternalScenarioContentTestBucket {
    return InternalScenarioContentTestBucketFromJSONTyped(json, false);
}

export function InternalScenarioContentTestBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalScenarioContentTestBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
        'count': json['count'],
    };
}

export function InternalScenarioContentTestBucketToJSON(json: any): InternalScenarioContentTestBucket {
    return InternalScenarioContentTestBucketToJSONTyped(json, false);
}

export function InternalScenarioContentTestBucketToJSONTyped(value?: InternalScenarioContentTestBucket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
        'count': value['count'],
    };
}

